import type { SVGProps } from 'react';
const DawnFlagCY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-CY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-CY_svg__a)">
      <path
        fill="#E7832C"
        d="M15.714 2.667c.286-.146.58.182.404.45l-.351.535a.5.5 0 0 1-.133.136l-1.437.975a.7.7 0 0 0-.1.084l-.02.02a.667.667 0 0 0 0 .933l.13.133a.667.667 0 0 1 0 .934l-.246.25a.67.67 0 0 1-.782.126.67.67 0 0 0-.906.297l-.104.212a.67.67 0 0 1-.384.337l-1.205.409a.7.7 0 0 1-.214.035h-.522a.67.67 0 0 0-.599.373l-.042.087a.667.667 0 0 1-.901.3l-1.396-.71a.7.7 0 0 1-.173-.127l-.78-.795a.67.67 0 0 1-.191-.467v-.425c0-.204.165-.369.369-.369.099 0 .194-.04.263-.11l.743-.757a.67.67 0 0 1 .476-.2h.285a.67.67 0 0 0 .633-.459l.189-.576a.667.667 0 0 1 .766-.446l1.888.384c.098.02.2.018.297-.007l1.876-.477a.7.7 0 0 0 .138-.052l.981-.5z"
      />
      <path
        fill="#445128"
        d="M11 12.8c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.523.534c0 .294.234.533.523.533"
      />
      <path
        fill="#445128"
        d="M14.96 9.535c.33.162.467.562.305.892-.35.712-1.013 1.195-1.507 1.483a6 6 0 0 1-.944.445l-.019.006-.006.002-.002.001h-.001l-.212-.623.212.624a.667.667 0 0 1-.43-1.263l.215.631-.214-.63.007-.003.04-.015q.055-.02.158-.064c.137-.06.325-.147.525-.264.422-.246.807-.563.981-.917a.667.667 0 0 1 .892-.305M7.04 9.535a.667.667 0 0 0-.305.892c.35.712 1.013 1.195 1.507 1.483a6 6 0 0 0 .944.445l.019.006.006.002.002.001h.001l.212-.623-.212.624a.667.667 0 0 0 .43-1.263l-.215.631.214-.63-.007-.003-.04-.015-.158-.064a5 5 0 0 1-.525-.264c-.423-.246-.807-.563-.981-.917a.667.667 0 0 0-.892-.305"
        opacity={0.75}
      />
    </g>
  </svg>
);
export default DawnFlagCY;
